import { render, staticRenderFns } from "./AgencyFees.vue?vue&type=template&id=363f272f"
import script from "./AgencyFees.vue?vue&type=script&setup=true&lang=js"
export * from "./AgencyFees.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AgencyFees.vue?vue&type=style&index=0&id=363f272f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports